import React, { useEffect, useState } from "react";
import axios from "axios";
import { createScenarioData, updateScenarioData } from "../api/scenarioData";
import ActiveStatusFilter from "../components/shared/ActiveStatusFilter";

export default function RiskOwnerManager() {
  const [owners, setOwners] = useState([]);
  const [form, setForm] = useState({
    name: "",
    department: "",
    active: true,
  });
  const [editingId, setEditingId] = useState(null);
  const [message, setMessage] = useState(null);
  const [showActive, setShowActive] = useState(true);

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage(null), 4000);
  };

  const loadOwners = async () => {
    const res = await axios.get("/api/digital-risk/risk-owners/");
    setOwners(res.data);
  };

  useEffect(() => {
    loadOwners();
  }, []);

  const saveOwner = async () => {
    try {
      if (!form.name.trim()) {
        showMessage("error", "Owner name is required.");
        return;
      }

      if (editingId) {
        await updateScenarioData("riskOwners", editingId, form);

        showMessage("success", "Risk owner updated successfully.");
      } else {
        await createScenarioData("riskOwners", form);

        showMessage("success", "Risk owner created successfully.");
      }

      setForm({
        name: "",
        department: "",
        active: true,
      });

      setEditingId(null);
      await loadOwners();
    } catch (error) {
      console.error(error.response?.data || error);
      showMessage("error", "Unable to save risk owner.");
    }
  };

  const editOwner = (owner) => {
    setEditingId(owner.id);
    setForm({
      name: owner.name || "",
      department: owner.department || "",
      active: owner.active,
    });
  };

  return (
    <div className="p-6 space-y-6">
      {/*   
      <div className="bg-sky-950 text-white rounded-3xl p-7 shadow-sm">
        <p className="text-xs uppercase tracking-[0.25em] text-slate-400">
          Scenario Modeling
        </p>

        <div className="flex flex-col xl:flex-row xl:items-end xl:justify-between gap-6 mt-3">
          <div>
            <h1 className="text-3xl font-bold">
              Risk Owner Manager
            </h1>

            <p className="text-slate-300 mt-2 max-w-3xl">
              Manage accountable owners used across risks and mitigation initiatives.
            </p>
          </div>

        </div>
      </div>
      */}
      {message && (
        <div
          className={`px-4 py-3 rounded-xl text-sm font-medium ${
            message.type === "success"
              ? "bg-green-100 text-green-800 border border-green-200"
              : "bg-red-100 text-red-800 border border-red-200"
          }`}
        >
          {message.text}
        </div>
      )}

      <div className="bg-white border rounded-2xl p-5">
        <h2 className="font-semibold mb-4">
          {editingId ? "Edit Risk Owner" : "New Risk Owner"}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <input
            value={form.name}
            onChange={(e) =>
              setForm({
                ...form,
                name: e.target.value,
              })
            }
            placeholder="Owner name"
            className="border rounded-xl px-4 py-3"
          />

          <input
            value={form.department}
            onChange={(e) =>
              setForm({
                ...form,
                department: e.target.value,
              })
            }
            placeholder="Department"
            className="border rounded-xl px-4 py-3"
          />

          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={form.active}
              onChange={(e) =>
                setForm({
                  ...form,
                  active: e.target.checked,
                })
              }
            />
            Active Owner
          </label>
        </div>

        <div className="flex gap-3 mt-5">
          <button
            onClick={saveOwner}
            className="bg-slate-900 text-white px-5 py-3 rounded-xl"
          >
            {editingId ? "Update" : "Create"}
          </button>

          {editingId && (
            <button
              onClick={() => {
                setEditingId(null);
                setForm({
                  name: "",
                  department: "",
                  active: true,
                });
              }}
              className="border px-5 py-3 rounded-xl"
            >
              Cancel
            </button>
          )}
        </div>
      </div>

      <div className="bg-white border rounded-2xl p-5">
        <h2 className="font-semibold mb-4">
          Risk Owners
        </h2>
        <ActiveStatusFilter value={showActive} onChange={setShowActive} />

        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-gray-500">
              <th className="text-left py-3">Name</th>
              <th className="text-left py-3">Department</th>
              <th className="text-left py-3">Status</th>
              <th className="text-left py-3">Actions</th>
            </tr>
          </thead>

          <tbody>
            {owners.filter((owner) => owner.active === showActive).map((owner) => (
              <tr key={owner.id} className="border-b">
                <td className="py-3 font-medium">
                  {owner.name}
                </td>

                <td className="py-3">
                  {owner.department || "-"}
                </td>

                <td className="py-3">
                  {owner.active ? "Active" : "Inactive"}
                </td>

                <td className="py-3">
                  <button
                    onClick={() => editOwner(owner)}
                    className="text-slate-700 hover:text-black"
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))}

            {owners.length === 0 && (
              <tr>
                <td
                  colSpan="4"
                  className="py-6 text-center text-gray-400"
                >
                  No risk owners found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
